export default "__VITE_ASSET__BxmLJXoS__"